export default "__VITE_ASSET__BXvIdu$S__"